import { render, staticRenderFns } from "./select-pig-sty.vue?vue&type=template&id=faa21344&scoped=true&"
import script from "./select-pig-sty.vue?vue&type=script&lang=js&"
export * from "./select-pig-sty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa21344",
  null
  
)

export default component.exports